import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

const LOCATION_SUGGESTIONS_QUERY = gql`
  query locationSuggestions($query: String!, $city: String, $country: String, $coordinates: [Float]) {
    locationSuggestions(query: $query, city: $city, country: $country, coordinates: $coordinates) {
      address
      municipality
      region
      postalCode
      country
      label
    }
  }
`

export interface UseLocationSuggestionsOptions {
  query: string
  city?: string
  country?: string
  coordinates?: number[]
  skip?: boolean
}

export function useLocationSuggestions({
  query,
  city,
  country,
  coordinates,
  skip = false
}: UseLocationSuggestionsOptions) {
  const { data, loading, error } = useQuery(LOCATION_SUGGESTIONS_QUERY, {
    skip: skip || !query,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: false,
    variables: {
      query,
      coordinates,
      city,
      country
    }
  })

  const suggestions = data?.locationSuggestions ?? []

  return {
    suggestions,
    loading,
    error
  }
}
